export const TiptapMenubar = (props: any) => (
   <div
      className="sticky top-0 z-[1] flex flex-wrap rounded-md border border-gray-300 bg-gray-50 p-1"
      {...props}
   >
      {props.children}
   </div>
);
